import SimpleDictionaryFormConfig from "../../../components/common/SimpleDictionaryFormConfig";

const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "blisterHeight",
            label: t ? t("common.height_blister_mm") : "Wysokość blistra (mm)",
            column: 1,
            type: "number",
            scale: 2
        },
        {
            name: "tabletCountInBlister",
            label: t ? t("common.tablets_count_in_blister") : "Liczba tabletek w blistrze",
            column: 1,
            type: "number",
            integer: true,
        },
        {
            name: "coveringFoil",
            label: t ? t("common.covering_foil") : "Folia pokrywająca",
            column: 1,
            type: "dictionary",
            dictionary: "coveringFoil",
            creationForm: SimpleDictionaryFormConfig(t)
        },
        {
            name: "coveringFoilThickness",
            label: t ? t("common.covering_foil_thickness") : "Grubość folii pokrywającej (µm)",
            column: 1,
            type: "number",
            integer: true,
        },
        {
            name: "coveringFoilWidth",
            label: t ? t("common.covering_foil_width") : "Szerokość folii pokrywającej (mm)",
            column: 1,
            type: "number",
            integer: true,
        },
        {
            name: "moldedFoil",
            label: t ? t("common.formed_foil") : "Folia formowana",
            column: 1,
            type: "dictionary",
            dictionary: "moldedFoil",
            creationForm: SimpleDictionaryFormConfig(t)
        },
        {
            name: "moldedFoilThickness",
            label: t ? t("common.formed_foil_thickness") : "Grubość folii formowanej (µm)",
            column: 1,
            type: "number",
            integer: true,
        },
        {
            name: "moldedFoilWidth",
            label: t ? t("common.formed_foil_width") : "Szerokość folii formowanej (mm)",
            column: 1,
            type: "number",
            integer: true,
        },
        {
            name: "coding",
            label: t ? t("common.coding") : "Kodowanie",
            column: 1,
            type: "boolean"
        },
        {
            name: "perforation",
            label: t ? t("common.perforation") : "Perforacja",
            column: 1,
            type: "boolean"
        },
        {
            name: "blisterSizeComponent",
            column: 2,
            type: "component",
            config: {columns: 2}
        },
        {
            name: "blisterSizeX",
            label: t('forms.x_dimenion'),
            column: 1,
            type: "number",
            scale: 2,
            component: "blisterSizeComponent",

        },
        {
            name: "blisterSizeY",
            label: t('forms.y_dimension'),
            column: 1,
            type: "number",
            scale: 2,
            component: "blisterSizeComponent",
        },
        {
            name: "imageLegend2",
            column: 2,
            type: "staticImage",
            fileName: "blister_size.png",
            component: "blisterSizeComponent",
            mandatory: true
        },
        {
            name: "alarmCount",
            label: t ? t("common.alarm_count") : "Liczba alarmów",
            column: 1,
            type: "number",
            integer: true,
        }
    ]
});

export default fields;
